export function ProductPreview() {
  return (
    <div className="hero-product" aria-label="Author publicity dashboard preview">
      <div className="product-window">
        <div className="window-bar"><span /><span /><span /><strong>Author Campaign Overview</strong></div>
        <div className="dashboard-grid">
          <aside className="side-rail">{["Plan", "Pitch", "Book", "Report"].map((item) => <span className={item === "Plan" ? "active" : ""} key={item}>{item}</span>)}</aside>
          <div className="hero-panel">
            <div className="panel-heading"><div><p>Launch readiness</p><h3>Memoir interview tour</h3></div><span className="status-pill">On schedule</span></div>
            <div className="radial-score"><strong>92</strong><span>media fit score</span></div>
            <div className="sparkline" aria-hidden="true">{[36, 54, 44, 68, 61, 78, 86, 91].map((height, index) => <i key={index} style={{ height: `${height}%` }} />)}</div>
          </div>
          <div className="hero-panel compact"><p>Pitch recommendation</p><h4>Lead with the author's personal turning point before introducing the book's broader theme.</h4></div>
          <div className="hero-panel compact"><p>Channel mix</p><div className="coverage-bars"><span style={{ width: "72%" }}>Print</span><span style={{ width: "56%" }}>Podcast</span><span style={{ width: "46%" }}>Book clubs</span></div></div>
        </div>
      </div>
    </div>
  );
}
